export const TIME_ZONE = 'Asia/Seoul'

export const IMAGE_PREVIEW_FORMAT = 'Y.MM.DD HH:mm'
export const IMAGE_DETAIL_FORMAT = 'dddd, YYYY-MM-DD, HH:mm a';
